module.exports = __webpack_public_path__ + "img/pwa-installed-award.5b8b25d2.png";